module.exports = __webpack_public_path__ + "static/media/crocodile.8774ce2a.png";